import React from "react";
import styles from "./extension-preview-slot.module.css";

export default function ExtensionPreviewSlot({
  children,
  isSelected = false,
  onClick,
  className = "",
}) {
  return (
    <div
      className={`${styles.slot} ${isSelected ? styles.slotSelected : ""} ${className}`.trim()}
      onClick={(e) => {
        const target = e.target;
        const isInputField =
          target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT" ||
          target.contentEditable === "true" ||
          target.closest("input, textarea, select, [contenteditable]");
        if (!isInputField) onClick?.(e);
      }}
    >
      {children}
    </div>
  );
}
